import script from "./showOther.vue?vue&type=script&setup=true&lang=js"
export * from "./showOther.vue?vue&type=script&setup=true&lang=js"

import "./showOther.vue?vue&type=style&index=0&id=715ba148&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-715ba148"]])

export default __exports__